<template>

    <v-container fill-height>
      <v-row justify="center" align="center" fill-height style="height: 100%">
        <v-col class="text-center">
          <div class="display-2">404</div>
          <div class="Headline">Not found this page</div>
        </v-col>
      </v-row>
    </v-container>

</template>

<script>
  

  export default {
    
  }
</script>
